<template>
  <div class="full-page-wrap">
    <div class="container">
      <div class="inner-page-wrap mt-5" style="min-height: calc(100vh - 257px)">
        <div class="partner-head">
          <h3 class="common-head">Key Partners</h3>
          <div class="filter-search-partner">
            <div class="position-relative w-100 category-search d-none">
              <v-select
                :items="PartnerCategories"
                item-text="Name"
                item-value="Id"
                dense
                height="38px"
                v-model="searchCategoryId"
              ></v-select>
              <img
                src="../assets/Images/filter-results-button - ash.svg"
                style="height: 18px; width: 18px"
                class="category-img"
              />
            </div>
            <input
              type="text"
              placeholder="Search Partners"
              v-model="searchText"
            />
          </div>
        </div>
        <v-row v-if="FilteredPartners.length>0" class="mt-12">
          <v-col
            v-for="(partner, index) in FilteredPartners"
            :key="index"
            md="3"
            sm="4"
            cols="6"
          >
            <div
              class="single-partner"
              @click="partner.Name ? openSposorBoothLink(partner) : null"
              :title="partner.Name ? '' : 'No Booth Mapped'"
            >
              <img :src="getCDNUrl(partner.Logo)" />
            </div>
          </v-col>
        </v-row>
        <v-row v-else class="mt-12">
          <v-col
            cols="12"
            class="text-center"
          >
            <h2 class="text-center mt-16"> No Data found. </h2>
          </v-col>
        </v-row>
      </div>
    </div>
    <div>
      <PublicFooter></PublicFooter>
    </div>
    <v-dialog v-model="openSponsorDialog" width="670px">
      <v-card v-if="currentPartner">
        <v-card-text class="p-0">
          <div class="position-relative partner-details-hld">
            <v-btn
              icon
              class="close-partner-details"
              @click="openSponsorDialog = false"
              ><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn
            >
            <div class="partner-details-wrap">
              <div class="partner-details-head">
                <h3 v-if="currentPartner.Name">
                  {{ currentPartner.Name }}
                  <span
                    ><v-icon color="#333" size="25px"
                      >mdi-bookmark-outline</v-icon
                    ></span
                  >
                </h3>
                <ul>
                  <li
                    v-if="currentPartner.SocialLinks.Facebook"
                    class="facebook"
                  >
                    <a
                      :href="currentPartner.SocialLinks.Facebook"
                      target="_blank"
                      ><img src="../assets/Images/icons/facebook.svg"
                    /></a>
                  </li>
                  <li v-if="currentPartner.SocialLinks.Twitter" class="twitter">
                    <a
                      :href="currentPartner.SocialLinks.Twitter"
                      target="_blank"
                      ><img src="../assets/Images/icons/twitter.svg"
                    /></a>
                  </li>
                  <li
                    v-if="currentPartner.SocialLinks.LinkedIn"
                    class="linkedin"
                  >
                    <a
                      :href="currentPartner.SocialLinks.LinkedIn"
                      target="_blank"
                      ><img src="../assets/Images/linkedin.svg"
                    /></a>
                  </li>
                  <li v-if="currentPartner.SocialLinks.YouTube" class="youtube">
                    <a
                      :href="currentPartner.SocialLinks.YouTube"
                      target="_blank"
                      ><img src="../assets/Images/icons/youtube-white.svg"
                    /></a>
                  </li>
                  <li
                    v-if="currentPartner.SocialLinks.Instagram"
                    class="instagram"
                  >
                    <a
                      :href="currentPartner.SocialLinks.Instagram"
                      target="_blank"
                      ><img src="../assets/Images/instagram.svg"
                    /></a>
                  </li>
                </ul>
              </div>
              <div v-html="currentPartner.Profile"></div>
              <ul class="contact-details-partner">
                <li v-if="currentPartner.Email">
                  <a href=""
                    ><v-icon color="#333" size="25px">mdi-email-outline</v-icon>
                    {{ currentPartner.Email }}</a
                  >
                </li>
                <li v-if="currentPartner.Phone">
                  <a href=""
                    ><v-icon color="#333" size="25px">mdi-phone-outline</v-icon>
                    {{ currentPartner.Phone }}</a
                  >
                </li>
              </ul>
              <v-btn
                class="tothe-booth"
                v-if="currentPartner.BoothId"
                @click="
                  goToBooth(currentPartner.BoothId, currentPartner.BoothName)
                "
                >Enter Booth
                <v-icon color="#ffffff" size="25px" class="ml-2"
                  >mdi-arrow-right</v-icon
                ></v-btn
              >
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import jQuery from "jquery";
// let $ = jQuery;
//var self;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import PublicFooter from "@/components/PublicFooter.vue";
// import axios from "axios";
// import { bus } from "@/main";
import router from "@/router";
import store from "@/store";

Vue.use(VueMoment, {
  moment,
});

var self;
export default {
  components: {
    PublicFooter,
  },
  metaInfo() {
    return {
      title: "World Youth Skills Day (Asia-Pacific) 2022",
      meta: [
        { property: "og:type", content: "website" },
        { name: "description", content: "ASIA-PACIFIC 2022" },
        {
          property: "og:title",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "og:url",
          content: location.host,
        },
        { property: "og:type", content: "website" },
        {
          property: "og:description",
          content:
            "Temasek Polytechnic in collaboration with UNESCO-UNEVOC, UNEVOC centres, local and regional partners.",
        },
        { property: "og:site_name", content: "Epiloge" },
        {
          property: "og:image",
          content:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FBranding%2F1200x628_1647965462226.png?alt=media&token=098e242f-7301-428b-80da-9afc9cebe25e",
        },
        {
          property: "twitter:card",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:title",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:description",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:url",
          content: location.host,
        },
        {
          property: "twitter:description",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:image",
          content:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FBranding%2F1200x628_1647965462226.png?alt=media&token=098e242f-7301-428b-80da-9afc9cebe25e",
        },
      ],
    };
  },
  data() {
    return {
      publicEventCollection: "",
      event_collectionName: "",
      openSponsorDialog: false,
      partnerCategories: [],
      currentPartner: null,
      Partners: [
        {
          Id: "1",
          Name: "UNESCO-UNEVOC International Centre for TVET",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2Fp1.jpg?alt=media",
          Profile:
            "<p>As UNESCO's only specialized centre for Technical and Vocational Education and Training (TVET), UNESCO-UNEVOC supports Member States in their efforts to strengthen and upgrade their TVET systems. UNESCO-UNEVOC promotes increased opportunities for productive work, sustainable livelihoods, personal empowerment and socio-economic development, especially for youth, women and the disadvantaged. Through its innovative projects, capacity-building programmes and collaborative activities with more than 220 UNEVOC Centres in over 140 countries around the globe, UNESCO-UNEVOC works to ensure equal access to quality skills training and development for all.</p>",
          Email: "unevoc@unesco.org",
          Phone: "4922 8534 19200",
          Website: "",
          CategoryId: "1",
          Category: "Company 1",
          Type: "",
          BoothNo: "",
          BoothId: "25977000",
          BoothName: "UNESCO-UNEVOC International Centre for TVET",
          SocialLinks: {
            Facebook: "https://www.facebook.com/unesco.unevoc.international",
            Twitter: "https://twitter.com/UNEVOC",
            LinkedIn: "https://www.linkedin.com/company/unevoc",
            YouTube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 1,
        },
        {
          Id: "2",
          Name: "National Youth Council",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1652714597901-nyc-logo-rgb.png?alt=media&token=079b1e46-a143-4e30-892c-39d6fb164287",
          Profile:
            "<p>At NYC, we believe in a world where young people are respected and heard, and have the ability to influence and make a difference to the world. Together with our partners, we develop future-ready youth who are committed to Singapore by instilling in them a heart for service, resilience and an enterprising spirit.</p>",
          Email: "nyc_enquiries@nyc.gov.sg",
          CategoryId: "2",
          Category: "Company 2",
          Type: "",
          BoothNo: "",
          BoothId: "25968000",
          BoothName: "National Youth Council",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "https://www.facebook.com/nycsg",
            Twitter: "https://twitter.com/nycsg?lang=en",
            LinkedIn: "https://www.linkedin.com/company/nycsg/",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 2,
        },
      {
          Id: "3",
          Name: "SkillsFuture Singapore",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1653301781187-skillsfuturesg_rgb-clear-background.png?alt=media&token=d892c70b-3f49-4098-a484-51680ae30caa",
          Profile:
            "<p><strong>SkillsFuture<strong></p> <p>SkillsFuture is a national movement to provide Singaporeans with the opportunities to develop their fullest potential throughout life, regardless of their starting points. Through this movement, the skills, passion and contributions of every individual will drive Singapore’s next phase of development towards an advanced economy and inclusive society.</p> <p>No matter where you are in life – schooling years, early career, mid-career, or silver years – you will find a variety of resources to help you attain master of skills. Skills mastery is more than having the right paper qualifications and being good at what you do currently; it is a mindset of continually striving towards greater excellence through knowledge, application and experience. With the help of the Future Economy Council, education and training providers, employers, union – you can own a better future with skills mastery and lifelong learning.</p><p><strong>SkillsFuture Singapore (SSG)</strong></p><p>SkillsFuture Singapore (SSG) drives and coordinates the implementation of the national SkillsFuture movement, promotes a culture of lifelong learning and strengthens the ecosystem of training and adult education in Singapore. Through a holistic, suite of national SkillsFuture initiatives, SSG enables Singaporeans to take charge of their learning journey in their pursuit of skills mastery. SSG also works with key stakeholders to ensure that students and adults have access to high quality and industry-relevant training that meet the demands of different sectors of the economy for an innovative and productive workforce. For more information visit <a href='www.ssg.gov.sg'>www.ssg.gov.sg</a></p>",
          Email: "",
          CategoryId: "3",
          Category: "Company 3",
          Type: "",
          BoothNo: "",
          BoothId: "25993000",
          BoothName: "SkillsFuture Singapore",
          Website: "",
          Phone: "6785 5785",
          SocialLinks: {
            Facebook: "https://www.facebook.com/skillsfuturesg",
            Twitter: "",
            LinkedIn: "https://www.linkedin.com/company/skillsfuture-sg/",
            Youtube: "",
            Instagram: "https://www.instagram.com/skillsfuturesg/",
          },
          Tags: "",
          DisplayOrder: 3,
        },
        {
          Id: "4",
          Name: "",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2Fp4.png?alt=media",
          Profile: "",
          Email: "",
          CategoryId: "4",
          Category: "Company 4",
          Type: "",
          BoothNo: "",
          BoothId: "",
          BoothName: "Booth Name",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "",
            Twitter: "",
            LinkedIn: "",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 4,
        },

        {
          Id: "5",
          Name: "Chitralada Technology Institute, Thailand",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2Fimage_2022_05_03T13_39_08_149Z.png?alt=media&token=56c98e1b-dee0-469c-98ae-dd38f603eb43",
          Profile:
            "<p>The educational institution, following HRH Princess Maha Chakri Sirindhorn's royal initiative: 'Study and Work - Work and Study', emphasizes technology and innovation, entrepreneurial potential, and the development of good people with skills, self-discipline, and professional ethics. CDTI offers three levels of education, including vocational certificates, diplomas or high vocational certificates, and bachelor degrees, with a work-integrated learning and instruction approach in various areas of technology both within the institute and in the real workplaces of more than 80-CDTI networking well-known Thai companies. The certificate and diploma programs are comprised of electronic technology, mechatronics, embedded systems, marketing, information and communication technology, food industry, Thai and international chef, Thai musical instrument craftsmanship, innovative agriculture, and railway engineering technologies. The bachelor’s degree programs cover the field of food business management, electrical engineering technology, and digital technology. CDTI has been engaging in helping students reach their highest potential, be able to create success for themselves, and take an active part in building a better society and a better world. In doing so, thereby, CDTI embraces the moral philosophy of devoting self to nation, religion and the monarch, having disciplines and morals to guide learning, and embracing hard work. The teaching and learning methods combine theoretical knowledge with vocational content, allowing students to demonstrate multi-dimensional abilities such as critical thinking, creative thinking, and practical skills. Students will also be encouraged to have a moral sense of duty, a passion for their profession, personal and civic responsibility, and a willingness to volunteer. These are important characteristics for CDTI graduates.</p>",
          Email: "inter.affairs@cdti.ac.th",
          CategoryId: "5",
          Category: "Company 5",
          Type: "",
          BoothNo: "",
          BoothId: "25971000",
          BoothName: "Chitralada Technology Institute, Thailand",
          Website: "",
          Phone: "+662-280-0551",
          SocialLinks: {
            Facebook: "https://www.facebook.com/ChitraladaTechnologyInstitute",
            Twitter: "https://twitter.com/cdtiofficial",
            LinkedIn: "",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 5,
        },

        {
          Id: "6",
          Name: "Jeonju University",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1651449654813-logo-jj.png?alt=media&token=04c00248-95b0-4878-ade6-681b1fd168a4",
          Profile: "",
          Email: "mtoanoglou@jj.ac.kr",
          CategoryId: "6",
          Category: "Company 6",
          Type: "",
          BoothNo: "",
          BoothId: "25987000",
          BoothName: "Jeonju University",
          Website: "",
          Phone: "+82632202440",
          SocialLinks: {
            Facebook:
              "https://www.linkedin.com/school/%EC%A0%84%EC%A3%BC%EB%8C%80%ED%95%99%EA%B5%90/",
            Twitter: "",
            LinkedIn:
              "https://www.linkedin.com/school/%EC%A0%84%EC%A3%BC%EB%8C%80%ED%95%99%EA%B5%90/",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 6,
        },

        {
          Id: "7",
          Name: "PASSAGE TO ASEAN",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1650938561033-untitled-design-2.png?alt=media&token=12dea1c1-3848-4e27-9e0d-d7f66ce02ff0",
          Profile:
            "<p>Passage to ASEAN (P2A) is a non-profit Network that was established in 2012 by five Institutes of Higher Education during the First Assembly of Representatives hosted by Rangsit University in Thailand and Duy Tan University in Vietnam. During this time, the concepts of P2A were established, which were based on the vision of the ASEAN Charter: “One Vision, One Identity” and creating “one caring and sharing community”. Passage to ASEAN is driven by the need for regional solidarity and a shared responsibility towards people and society as a whole. P2A was initiated with the principle that higher education should be a leader in the development of society. Together, they created a new model for affordable mobility with a clear objective and a measurable learning outcome that is consistent with the mission of developing Knowledge, Experience and Understanding amongst the ASEAN youth. Simultaneously a wide spectrum of related activities developed including, P2A Internships Programs, Community Service Learning, Workshops and Conventions, all in addition to conventional academic collaboration and student and staff exchanges. Today, Passage to ASEAN is uniquely positioned in that membership is open to any ASEAN Institute of Higher Education, thereby redirecting the focus from institutions and administrators to students. It is the open non-discriminatory membership policy that differentiates P2A from organizations such as the ASEAN University Network (AUN) and the ASEAN-EU initiative SHARE, as P2A enables every student to engage in ASEAN. Passage to ASEAN Association represents a network of 80 universities and colleges from 9 ASEAN countries and consists of more than 1.2 million students. In early 2016, the network officially became the P2A Association and registered its head office in Bangkok, Thailand. On 6th January 2020, the application of P2A to be an entity associated with ASEAN has been approved. P2A will be listed in Annex 2 of the ASEAN Charter under the category of “Think Tanks and Academic Institutions”</p>",
          Email: "p2asecretariat@passagetoasean.org",
          CategoryId: "7",
          Category: "Company 7",
          Type: "",
          BoothNo: "",
          BoothId: "25978000",
          BoothName: "PASSAGE TO ASEAN",
          Website: "",
          Phone: "0935292284",
          SocialLinks: {
            Facebook: "https://www.facebook.com/passage2asean",
            Twitter: "",
            LinkedIn: "",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 7,
        },

        {
          Id: "8",
          Name: "BINUS University",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1651028588487-logo-binus-university.png?alt=media&token=b3788f3b-6b1e-420c-886b-be1667e0d158",
          Profile:
            "<p>The journey of Bina Nusantara University began on October 21, 1974. It originated from a short-term course named Modern Computer Course, which then expanded because of its strong foundation and comprehensive vision. Due to the high demand and its rapid development, on July 1, 1981, Modern Computer Course had developed into ‘Akademi Teknik Komputer (ATK)’ or Computer Technical Academy with ‘Manajemen Informatika’ or Informatics Management as the first major. The ATK obtained registered on July 13, 1984 and a year after that, exactly on July 1, 1985, the institution changed into AMIK Jakarta. On September 21, 1985, AMIK Jakarta changed its name into AMIK Bina Nusantara. AMIK Bina Nusantara recorded a remarkable achievement in its relatively young age when it was chosen as the best Computer Academy by The Ministry of Education and Culture through The Higher Education Board District III on March 17, 1986. The need for professional workers in the Information Technology area drove AMIK further into development, and on July 1, 1986 it was officially listed as ‘Sekolah Tinggi Manajemen Informatika dan Komputer (STMIK)’ or Institute of Information Management and Computer Science Bina Nusantara. On November 9, 1987, a merger between AMIK Bina Nusantara and STMIK Bina Nusantara took place. The institution conducted Diploma (D-3) and Undergraduate (S-1) programs. An accreditation status of ‘Disamakan’ or ‘Equalized’ for all majors and levels was earned on March 18, 1992. On the next year, STMIK Bina Nusantara opened the first Masters (S-2) Program in Information System Management in Indonesia. The program was officially listed on May 10, 1993. After going through years of perseverance and hard work, Bina Nusantara University (Universitas Bina Nusantara or UBINUS) was officially listed and established on August 8, 1996. STMIK Bina Nusantara was then merged into Bina Nusantara University on December 20, 1998. At that time, UBINUS has Faculty of Computer Science (Fakultas Ilmu Komputer), Faculty of Economy (Fakultas Ekonomi), Faculty of Engineering (Fakultas Teknik), Faculty of Literature (Fakultas Sastra), Faculty of Mathematics and Natural Sciences (Fakultas MIPA) and Masters (S-2) Program in Information System Management. However, UBINUS did not stop there. It is continually expanding their reach on educational areas. On April 20, 2007, Bina Nusantara University added Faculty of Psychology (Fakultas Psikologi) and Faculty of Communication & Multimedia (Fakultas Komunikasi dan Multimedia) in their midst. Due to the new organizational structure of Bina Nusantara University, which is valid since August 19, 2008, the names of several faculties were changed. Faculty of Technical Science is now known as Faculty of Science and Technology, Faculty of Economy is now known as Faculty of Business & Economy, and Faculty of Literature is now known as Faculty of Language and Culture. Faculty of Mathematics and Natural Sciences is now merged within Faculty of Science and Technology. Meanwhile, on Masters (S-2) Program, UBINUS officially added another program, Masters in Informatics Engineering (Magister Teknik Informatika), on August 31, 2009. On September 7, 2011, UBINUS performed another structural change in the organization. Some of the changes are: 1. Faculty of Economy and Business is changed into Faculty of Economics and Communication. 2. Faculty of Psychology and Faculty of Language & Culture is merged into Faculty of Humanities (Fakultas Humaniora) 3. Faculty of Science and Technology is changed into Faculty of Engineering (Fakultas Teknik) 4. Information Technic Major is changed into School of Computer Science 5. Information System Major is changed into School of Information System 6. Management Major is changed into School of Business Management 7. Faculty of Communication and Multimedia is changed into School of Design 8. Computer System Major, which was previously listed on Faculty of Computer Science, is now listed on Faculty of Science and Technology 9. Mathematic and Statistic Major, which was previously listed on Faculty of Science and Technology, is now listed on School of Information System 10. Accounting Major is changed into School of Accounting and Finance 11. The Masters Program of Information System and Informatics Engineering is now under the coordination of BINUS Graduate Program, which also supervises Doctoral of Research in Management</p>",
          Email: "global@binus.edu",
          CategoryId: "8",
          Category: "Company 8",
          Type: "",
          BoothNo: "",
          BoothId: "25970000",
          BoothName: "BINUS University",
          Website: "",
          Phone: "+62 21 534 5830, +62 21 535 0660",
          SocialLinks: {
            Facebook: "https://www.facebook.com/universitasbinanusantara",
            Twitter:
              "https://twitter.com/BINUS_UNIV?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor",
            LinkedIn:
              "https://www.linkedin.com/school/universitas-bina-nusantara/",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 8,
        },

        {
          Id: "9",
          Name: "Department of Technical and Vocational Education and Training",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1651470611824-dtvet-logo-hd.png?alt=media&token=5e4d6679-03d4-4dd4-841a-9410231cda31",
          Profile:
            "<p>Welcome to Department of Technical and Vocational Education and Training (DTVET) . Department of Technical and Vocational Education and Training (DTVET) under Ministry of Science and Technology, Myanmar, is a focal TVET department of the country. DTVET has been making efforts with a vision to continuously train and develop the qualified technical and vocational human resources in line with industry needs to support the socio-economic development of the country. Its missions are: (a) to enhance the opportunity for every citizen to learn the vocational education (b) to support the employment opportunity and assist for raising per capital income. Under DTVET, there are 70 TVET institutes — 4 Government Technical Colleges, 24 Government Technical Institutes, 35 Government Technical High Schools, 6 Vocational Schools and one TVET Teacher Training College. These institutes offer a variety of 4-year-bachelor-of-technology courses, 3-year-diploma engineering courses, 2-year-certificate courses, and other competency-based short courses. As of 2019-2020, there have been 25,692 students and 3,508 Teachers at these 70 institutes. To ensure quality assurance in TVET and a demand-driven TVET system, DTVET is implementing a quality management system in accordance with international standards and upgrading teaching-learning and research sector by using effective and efficient technologies and methodologies. Regarding the World Youth Skills Day (APAC) 2022, DTVET has been working hard with accelerated momentum to equip the youth with the required skills essential for 21st century and to achieve advancement and innovation in technical and vocational education in the country.</p>",
          Email: "hrd@dtve.org",
          CategoryId: "9",
          Category: "Company 9",
          Type: "",
          BoothNo: "",
          BoothId: "25988000",
          BoothName:
            "Department of Technical and Vocational Education and Training",
          Website: "",
          Phone: "+959 43002534",
          SocialLinks: {
            Facebook: "",
            Twitter: "",
            LinkedIn: "",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 9,
        },

        {
          Id: "10",
          Name: "National Institute of Technology (KOSEN), Kumamoto College",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1650944577244-logo_nitkumamoto.png?alt=media&token=e28f4bef-b83c-444d-bff8-88b762b0ce0a",
          Profile: "",
          Email: "",
          CategoryId: "10",
          Category: "Company 10",
          Type: "",
          BoothNo: "",
          BoothId: "25984000",
          BoothName:
            "National Institute of Technology (KOSEN), Kumamoto College",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "",
            Twitter: "",
            LinkedIn: "",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 10,
        },

        {
          Id: "11",
          Name: "Universitas Pembangunan Nasional Yogyak",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1650958300958-image-83700542138469295167.png?alt=media&token=e6536074-fc51-4a27-a59a-ccfd3026b42b",
          Profile:
            "<p>Company description: Universitas Pembangunan Nasional “Veteran” Yogyakarta (UPNVY) is one of the finest state universities in Yogyakarta. Founded by the Indonesian veterans in 1958, UPNVY has distinctive values such as discipline, fighting spirit, creativity, nationalism, and excellence. Moreover, the university has a great motto called “Widya Mwat Yasa” from Sanskrit language which means science that has been acquired shall be utilized and dedicated towards the development of a just and prosperous Indonesian society based on the national philosophy, Pancasila, and the Constitution of 1945. Universitas Pembangunan Nasional “Veteran” Yogyakarta is renowned as the best university in mineral technology. However, there are also many more reputable majors such as industrial engineering, environmental engineering, agrotechnology, economics, international relations, communications and others. Today, 13,290 undergraduate students and 469 master students are putting their beliefs in 468 teaching staff of UPNVY for their better future; and more than 50,000 alumni are widely spread all over the country, embracing their successful careers.</p>",
          Email: "oia@upnyk.ac.id",
          CategoryId: "11",
          Category: "Company 11",
          Type: "",
          BoothNo: "",
          BoothId: "26049000",
          BoothName: "Universitas Pembangunan Nasional Yogyak",
          Website: "",
          Phone: "+6283187314857",
          SocialLinks: {
            Facebook: "",
            Twitter: "",
            LinkedIn:
              "https://www.linkedin.com/company/office-of-international-affairs-upn-veteran-yogyakarta/?originalSubdomain=id",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 11,
        },

        {
          Id: "12",
          Name: "Vocational Training Council, Hong Kong",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1651219341009-vtc_colour_logo--transparent-2to1.png?alt=media&token=95d3d43d-df8f-468b-8c5e-5233d5aea182",
          Profile:
            "<p>The Vocational Training Council (VTC) is the largest vocational education, training and professional development group in Hong Kong. Established in 1982, the VTC provides valuable credentials for some 200,000 students each year through a full range of pre-employment and in-service programmes with internationally recognised qualifications.</p>",
          Email: "",
          CategoryId: "12",
          Category: "Company 12",
          Type: "",
          BoothNo: "",
          BoothId: "26078000",
          BoothName: "Vocational Training Council, Hong Kong",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "https://www.facebook.com/vtc.hk/",
            Twitter: "",
            LinkedIn:
              "https://www.linkedin.com/company/vocational-training-council/?originalSubdomain=hk",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 12,
        },

        {
          Id: "13",
          Name: "Universitas Islam Indonesia",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1651368443630-logouii-smallest.png?alt=media&token=64a45b40-3d01-44c6-bc67-0e3012c1a755",
          Profile:
            "<p>Universitas Islam Indonesia is a leading national university and one of the Top 500 QS Asia Universities Rankings. UII commits to enhancing innovations and enriching benefits within communities across the globe. In 2021 UII achieved as an excellent accredited institution with 17 study programs are also accredited in a superb category by the National Accreditation Agency for Higher Education. Our leading research includes essential oil, herbal pharmacy, Islamic law, Islamic finance, Islamic Psychology, informatics medicine, water management, entrepreneurship, and disaster resilience. Studying at UII provides an engaging multicultural experience with students from various regions in Indonesia who came from overseas. UII has 28,000 students from 8 faculties with 25 undergraduate programs and 13 international programs, 23 master programs, 4 doctorate programs, 4 diploma programs, and 3 professional programs. More than 107,000 alumni are serving Indonesia and the world in many fields and many ways while maintaining professionalism and ethical values, to which UII's vision is anchored. Our international students come from 23 countries, and UII offers Future Global Leaders scholarships for prospective international students. UII was founded on 8 July 1945 and became the pioneer of national higher education in Indonesia. UII standing on a hillside became the largest and the most stunning on the north side of Yogyakarta. Our university is awarded Green Campus, strengthening our commitment to a sustainable environment in Indonesia and globally. Moreover, Yogyakarta is the country's 'capital' of education, culture, and arts. With its long history of civilization, Yogyakarta is a vibrant center for contemporary culture and classical arts. Known as 'Jogja', Yogyakarta is an exciting and comfortable place to study. Life runs quietly and subtly with Javanese culture's gentle touch, which seems to dominate the city. For further information, visit us at https://www.uii.ac.id/en/ and reach us at partnership@uii.ac.id.</p>",
          Email: "partnership@uii.ac.id",
          CategoryId: "13",
          Category: "Company 13",
          Type: "",
          BoothNo: "",
          BoothId: "25976000",
          BoothName: "Universitas Islam Indonesia",
          Website: "",
          Phone: "+62274898444",
          SocialLinks: {
            Facebook: "https://www.facebook.com/Universitas.Islam.Indonesia/",
            Twitter: "",
            LinkedIn: "",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 13,
        },

        {
          Id: "14",
          Name: "Iloilo Science and Technology University",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1650965180156-cbacf715-e20f-4c1c-9cf7-9eb9ca25ed3e.png?alt=media&token=7fafecfa-2c50-47a3-8ac4-144887be0713",
          Profile: "",
          Email: "mail@isatu.edu.ph",
          CategoryId: "14",
          Category: "Company 14",
          Type: "",
          BoothNo: "",
          BoothId: "25982000",
          BoothName: "Iloilo Science and Technology University",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "https://www.facebook.com/isatuniversitypio",
            Twitter: "",
            LinkedIn: "",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 14,
        },

        {
          Id: "15",
          Name: "University of Tun Hussien Onn, Malaysia",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1650976946526-index.png?alt=media&token=18875520-ed56-4f18-8b1d-25accb5400d1",
          Profile:
            "<p>The university was formerly known as Pusat Latihan Staf Politeknik ( PLSP ) which was established on September 16 , 1993. The core business of PLSP then was to train and produce polytechnics academic staff to become knowledgeable and skilful in various engineering fields. The training institute was jointly administered by Universiti Teknologi Malaysia and the Ministry of Education Malaysia. Three years later , PLSP was upgraded to Institut Teknologi Tun Hussein Onn ( ITTHO ). Dato’ Sri Mohd Najib bin Tun Abdul Razak who was then the Minister of Education made the official announcement of the new status on April 12 , 1996. This promotion was an acknowledgment of the institution's excellence in producing human resources for technical education. On September 27 , 2000 , the institute achieved another milestone when the Malaysian government agreed to award a university-college status to the institute. This status served to recognise its contributions in the development of science and technology as well as its role in helping the nation to achieve its aspirations. With its new status , the institution was renamed as Kolej Universiti Teknologi Tun Hussein Onn ( KUiTTHO ) and the official announcement was made by Tan Sri Dato’ Seri Musa bin Mohamed , the then Minister of Education. KUiTTHO continued to progress and produce skilful , knowledgeable and competitive graduates. Consequently , the Malaysian government , on September 20 , 2006 , agreed to award the university-college a full university status and changed its name to Universiti Tun Hussein Onn Malaysia. On February 1 , 2007 , Datuk Mustapha Mohamed , the Minister of Higher Education officially announced the change of status. Subsequently , Dato’ Seri Hishamuddin Tun Hussein Onn made the official declaration of the change of name on March 2 , 2007.</p>",
          Email: "affero@uthm.edu.my",
          CategoryId: "15",
          Category: "Company 15",
          Type: "",
          BoothNo: "",
          BoothId: "25974000",
          BoothName: "University of Tun Hussien Onn, Malaysia",
          Website: "",
          Phone: "+60197789843",
          SocialLinks: {
            Facebook: "https://www.facebook.com/uthmjohor/",
            Twitter: "https://twitter.com/uthmjohor?lang=en",
            LinkedIn: "https://www.linkedin.com/groups/6670690/",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 15,
        },

        {
          Id: "16",
          Name: "Zhejiang Technical Institute of Economics (ZJTIE) China",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1651645366671-logo-zhejiang-technical.png?alt=media&token=f3e2ee5c-5afe-45a2-8967-c6b4b13bf3cd",
          Profile:
            "<p>Zhejiang Technical Institute of Economics (ZJTIE) is a full-time public provincial vocational college previously known as Zhejiang Provincial Materials School established in 1978. In March 2000, Zhejiang Technical Institute of Economics was planned for construction. It was approved officially in January 2002 by the people’s government of Zhejiang province to upgrade into a higher vocational college. In July 2017, approved by the people’s government of Zhejiang province, it was included into Zhejiang Machinery and Electrical Group and Zhejiang Vocational Education Group was established. Adhering to the schooling philosophy of “Morality as Orientation, Practice as Foundation, Excellence as Pursuit, Optimization as Aim”, sticking to the socialist education orientation and the fundamental task of cultivating talents, and responding to the new education demand of supply chain integrated service industry against the intelligent business background, ZJTIE is dedicated to the development road of profession, specialization and high altitude to build the school a supply chain industry institute of full value, full-system integration and high level. ZJTIE has 9 secondary schools which are the Logistics and Supply Chain Management School, Automobile Technology School, Digital Information Technology School, Business Administration School, Commerce Circulation School, Finance and Accounting School, Culture and Art School, Dream and Entrepreneurship School, Marxism School, and a Further Education School. ZJTIE has more than 30 majors including logistics management, customs declaration and international freight, e-commerce, and financial management, etc. And three undergraduate majors in logistics management, e-commerce, and automotive maintenance engineering education were jointly established with Zhejiang Gongshang University and Zhejiang Normal University. ZJTIE has nearly 10,000 full-time students, including more than 500 undergraduates. ZJTIE is one of the first-batch Excellent National Backbone Vocational Colleges. It is listed among the first-batch pilot four-year vocational colleges for talents cultivation. ZJTIE boasts strong industry background and is supported by industry leading groups that it has close industry and teaching cooperation with Zhejiang Materials Industry Group Corporation (ZJMI), Lenovo Group, Geely Group, etc. In 2016, the SASAC Party School of Zhejiang Province was established in ZJTIE and it has become the training base for party members and cadres from the state-owned companies of the entire province. Being a UNESCO-UNEVOC Centre, ZJTIE has taken part in multilateral negotiation on UNESCO vocational education policy framework, has hosted or participated international leading vocational education research programs funded by UNESCO, and has undertaken international vocational education forums and high-level international education and training expert seminars. It has many projects including UNESCO Chinese Higher Vocational Education Joint Reform Plan Higher Vocational Education Teacher Education and Training. As one of the first-batch “Zhejiang International Characteristic Higher Education Institutes”, it attaches great importance to cooperation with international superior vocational education resources that it has conducted cooperative teaching with quality institutions from the U.K. and Singapore, it has recruited international students to study in ZJTIE. It has set up “ZJTIE-CIEDI International Education Center” in Cambodia, and initiated to establish the The Belt & Road Alliance for International Applied Education and Training in which it takes the post of the General Secretary. ZJTIE has vigorously promoted cultural quality education, and attached great importance to cultivating smart harmonious professional workers adaptive to the new demands of globalized and intelligent era, with coordinated development of professional ability, universal ability and high quality, and making good use of intelligent technologies. Over recent ten years, the enrollment score of ZJTIE has ranked among the first of similar higher vocational education colleges in Zhejiang province, and the employment rate has been kept over 98%.</p>",
          Email: "dyb@zjtie.edu.cn",
          CategoryId: "16",
          Category: "Company 16",
          Type: "",
          BoothNo: "",
          BoothId: "25969000",
          BoothName: "Zhejiang Technical Institute of Economics (ZJTIE) China",
          Website: "",
          Phone: "0571-86928099",
          SocialLinks: {
            Facebook: "",
            Twitter: "",
            LinkedIn: "",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 16,
        },

        {
          Id: "17",
          Name: "Temasek Launchpad",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1651843204975-invention-convention-backdrop.png?alt=media&token=dfa72b89-c018-462e-9863-8b59767c53e5",
          Profile: "",
          Email: "",
          CategoryId: "17",
          Category: "Company 17",
          Type: "",
          BoothNo: "",
          BoothId: "26001000",
          BoothName: "Temasek Launchpad",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "https://www.facebook.com/tp.innovation.entrepreneurship",
            Twitter: "",
            LinkedIn: "",
            Youtube: "",
            Instagram: "https://www.instagram.com/temaseklaunchpad/",
          },
          Tags: "",
          DisplayOrder: 17,
        },

        {
          Id: "18",
          Name: "Tune Map Indonesia",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1652152586635-logo-tune-map.png?alt=media&token=554d7530-7906-4a7a-b2f6-da6b9c1e6bb0",
          Profile:
            "<p>Tune map is a mobile application to empower people with visual impairment mobility by providing them information about city accessibility given by sighted citizens. Tune Map enabling you to share your knowledge about the city accessibility with visually impaired citizen anywhere and anytime. Capture unsafe conditions of city pavements (i.e. holes, no guiding block, etc). Submit the report through Tune Map. In return, reporters could get rewards provided by businesses as it CSR activity & promotion. Visually-impaired people request help through Tune Map and sighted-user will pin their destination as well as give suggestions based on collected reports. Help visually-impaired people reach their destination safely. In addition to that, Tune Map is also holding an offline campaign called #MapMyDay. #MapMyDay is an organized and scalable activity to raise awareness and educate people on disability and city accessibility which includes a participatory process that allows citizens to interact with visually impaired people and collect data about city accessibility using Tune Map.</p>",
          Email: "tunemap.id@gmail.com",
          CategoryId: "18",
          Category: "Company 18",
          Type: "",
          BoothNo: "",
          BoothId: "26071000",
          BoothName: "Tune Map Indonesia",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "https://www.facebook.com/tunemapid/",
            Twitter: "https://twitter.com/tunemapid?lang=en",
            LinkedIn: "",
            Youtube: "",
            Instagram: "https://www.instagram.com/tunemap.id/?hl=en",
          },
          Tags: "",
          DisplayOrder: 18,
        },

        {
          Id: "19",
          Name: "Duy Tan_University - Hospitality & Tourism Institute (DTU-HTi)",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1651733899780-logo---dtu-hti.png?alt=media&token=188247bb-af43-4dfa-8dfe-54ec115f65f5",
          Profile:
            "<p>The largest and most famous tourism training institution in Vietnam</p>",
          Email: "greetings@dtu-hti.edu.vn",
          CategoryId: "19",
          Category: "Company 19",
          Type: "",
          BoothNo: "",
          BoothId: "25972000",
          BoothName:
            "Duy Tan_University - Hospitality & Tourism Institute (DTU-HTi)",
          Website: "",
          Phone: "+84 236 3 650 403 (ext: 301)",
          SocialLinks: {
            Facebook: "https://www.facebook.com/DuyTanHTi",
            Twitter: "",
            LinkedIn:
              "https://www.linkedin.com/company/duy-tan-university/?originalSubdomain=vn",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 19,
        },

        {
          Id: "20",
          Name: "AIESEC in Singapore",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1651146670464-blue-logo.png?alt=media&token=109b1ef5-6231-4fc2-8445-6fdcbb6a9d35",
          Profile:
            "<p>AIESEC is a global platform for young people to explore and develop their leadership potential. We are a non-political, independent, not-for-profit organisation run by students and recent graduates of institutions of higher education. Its members are interested in world issues, leadership and management. AIESEC does not discriminate on the basis of ethnicity, gender, sexual orientation, religion or national/social origin.</p>",
          Email: "singapore@aiesec.org.sg",
          CategoryId: "20",
          Category: "Company 20",
          Type: "",
          BoothNo: "",
          BoothId: "25996000",
          BoothName: "AIESEC in Singapore",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "",
            Twitter: "",
            LinkedIn: "https://www.linkedin.com/company/aiesecsingapore",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 20,
        },

        {
          Id: "21",
          Name: "Hanoi University of Science and Technology",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1652429934383-microsoftteams-image--17.png?alt=media&token=6476ae9f-6b8c-4361-8d3f-06af5a682930",
          Profile:
            "<p>Welcome to Hanoi University of Science and Technology (HUST) – the first prestigious and influential multidisciplinary technical university in Vietnam! Since establishment of university, HUST has been committed to research, knowledge development and intellectual training for the society. The university gains the reputation of being the first and the leading technical university in Vietnam thanks to generations of influential alumni. With our great traditions and values, HUST maintains the teaching and learning quality while embracing innovative changes to meet the needs of students and society, especially in the era of digital economy and globalization. The development strategies for the period of 2017 – 2025 have been implemented effectively for 3 years and strategic plans have been recognized for the period of 2020 – 2025. HUST has earned a reputation for an influential university in the region and the world thanks to high-quality and well-trained lecturers, modern facilities, and research achievements. HUST is also known as the most attractive destination for talented students in science, engineering, and technology. As a higher education institution, HUST was accredited in 2017 by HCERES. In 2020, HUST was in the top of best universities in Asia according to Times Higher Education. According to QS World Ranking by subjects 2022, all five subjects of Hanoi University of Science and Technology have increased their rankings this year, ranked 1st in Vietnam and 300-450th in the world. Engineering and Technology, assessed as the University’s strongest broad subject area, is placed at rank 360 in the world for the first time While the Fourth Industrial Revolution opens up great opportunities, it also brings about unpredictable challenges. HUST continues its noble mission to research, knowledge development and intellectual training for the society. With a strong commitment, HUST maintains innovations for becoming the leading regional research university in engineering, science and technology and a model of comprehensive autonomous university with sustainable development, making significant contribution to the society and Vietnam higher education. An attractive campus and a professional working environment make HUST a trustworthy home with respect, solidarity, dedication for students, staff, and lecturers to together bring about innovation, breakthroughs, and success.</p>",
          Email: "htdn@hust.edu.vn",
          CategoryId: "21",
          Category: "Company 21",
          Type: "",
          BoothNo: "",
          BoothId: "25973000",
          BoothName: "Hanoi University of Science and Technology",
          Website: "",
          Phone: "(243) 869-3796",
          SocialLinks: {
            Facebook: "https://www.facebook.com/dhbkhanoi",
            Twitter: "",
            LinkedIn:
              "https://www.linkedin.com/school/%C4%91h-b%C3%A1ch-khoa-h%C3%A0-n%E1%BB%99i/",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 21,
        },

        {
          Id: "22",
          Name: "FPT University",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1652714453564-fptu-global-png-01.png?alt=media&token=00ba12e8-3b33-47ce-86cb-c44c47d39d76",
          Profile:
            "<p>FPT Education Global (FEG) is a department affiliated with FPT University, in charge of students international mobility programs. FEG programs range from long-term Semester Abroad and Internships to short-term Study Tours. With a Vision to create an International study space that is truly global, FEG strives to provide international students with well-designed and affordable programs that can equip students with unique experiences and transferable skills.</p>",
          Email: "exchange@fpt.edu.vn",
          CategoryId: "22",
          Category: "Company 22",
          Type: "",
          BoothNo: "",
          BoothId: "26047000",
          BoothName: "FPT University",
          Website: "",
          Phone: "(919) 712-298",
          SocialLinks: {
            Facebook: "https://www.facebook.com/FPTEducationGlobal/",
            Twitter: "",
            LinkedIn: "https://www.linkedin.com/company/fpt-education-global/",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 22,
        },

        {
          Id: "23",
          Name: "nEbO",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1653380748355-nebo-logo-cmyk.png?alt=media&token=d1e0ab3e-a1de-4a09-9850-c79ca010088b",
          Profile:
            "",
          Email: "advisors@nebo.com.sg",
          CategoryId: "23",
          Category: "Company 23",
          Type: "",
          BoothNo: "",
          BoothId: "25992000",
          BoothName: "nEbO",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "https://www.facebook.com/nEbOSG/",
            Twitter: "",
            LinkedIn: "",
            Youtube: "",
            Instagram: "https://www.instagram.com/nebosg/",
          },
          Tags: "",
          DisplayOrder: 23,
        },

        {
          Id: "24",
          Name: "Rangsit University",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1653635901437-3-3-rsu_logo_scolors_e.png?alt=media&token=e7e56019-6a98-4d53-be84-ffeac30f8008",
          Profile:
            "<p>Rangsit University Rangsit University is a higher education institution that has been assessed by the Office for Accreditation and Quality Assessment (ONESQA) to be the only private university that has been rated as 'very good' among institutions that focus on producing graduates. Teaching and learning by dividing the faculties into 5 groups as follows: Faculty of Medicine and Health Sciences Group : College of Medicine College of Dentistry College of Pharmacy Faculty of Medical Technology Faculty of Nursing Faculty of Physical Therapy and Sports Medicine Faculty of Science Faculty of Optometry College of Oriental Medicine Faculty of Radiological Technology and the College of Biomedical Engineering. Faculty of Engineering and Technology Group : College of Engineering College of Digital Innovation and Information Technology College of Agricultural Innovation and Food Technology and aviation institute Faculty of Humanities and Social Sciences Group : College of Social Innovation international college China International College Institute of Diplomacy and Foreign Affairs Faculty of Arts College of Communication Arts Faculty of Arts Faculty of Law Suriyathep Teachers College Criminology and Justice Administration College of Political Science, Economics and Globalization Institute of Public Administration and Public Policy political science institute institute of economics and graduate school Faculty of Art and Design Group : College of Music Faculty of Architecture college of design and the Faculty of Digital Art Faculty of Economics and Business Group: Faculty of Business Administration, Faculty of Accounting, College of Tourism and Hospitality Currently, it offers 83 bachelor's degree programs, 36 master's degree programs, and 11 doctoral programs, totaling 130 courses.</p>",
          Email: "info@rsu.ac.th",
          CategoryId: "24",
          Category: "Company 24",
          Type: "",
          BoothNo: "",
          BoothId: "25979000",
          BoothName: "Rangsit University",
          Website: "",
          Phone: "02-791-6000",
          SocialLinks: {
            Facebook: "https://www.facebook.com/rangsituniversity",
            Twitter: "",
            LinkedIn: "",
            Youtube: "",
            Instagram: "https://www.instagram.com/rangsitu/?hl=en",
          },
          Tags: "",
          DisplayOrder: 24,
        },

        {
          Id: "25",
          Name: "AMF",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1653835024304-logo.png?alt=media&token=de836222-3eb9-4856-a72d-8e6693a56458",
          Profile:
            "",
          Email: "shiiki.amf@gmail.com",
          CategoryId: "25",
          Category: "Company 25",
          Type: "",
          BoothNo: "",
          BoothId: "26072000",
          BoothName: "AMF",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "",
            Twitter: "https://mobile.twitter.com/rikashiikiamf",
            LinkedIn: "",
            Youtube: "",
            Instagram: "https://www.instagram.com/rikashiiki/",
          },
          Tags: "",
          DisplayOrder: 25,
        },

        {
          Id: "26",
          Name: "City of Balanga, Philippines",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1653637422574-cropped-logo-400px.png?alt=media&token=d3ebb968-7bd9-4e12-afa4-1e25fbe19de3",
          Profile:
            "",
          Email: "ceedo.cob@gmail.com",
          CategoryId: "26",
          Category: "Company 26",
          Type: "",
          BoothNo: "",
          BoothId: "26068000",
          BoothName: "City of Balanga, Philippines",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "",
            Twitter: "",
            LinkedIn: "",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 26,
        },

        {
          Id: "27",
          Name: "SG Enable",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1653983710057-sge-logo-2020_v1.png?alt=media",
          Profile:
            "<p>SG Enable seeks to enable persons with disabilities to live, learn, work and play in an inclusive society. The focal agency for disability in Singapore, it raises awareness on disability issues and facilitates access to disability schemes and services. It brings partners together to share knowledge, collaborate and innovate, striving towards a common goal of building an inclusive Singapore and enabling lives. Set up by the Ministry of Social and Family Development in 2013, it is a registered charity and an Institution of a Public Character.</p>",
          Email: "contactus@sgenable.sg",
          CategoryId: "27",
          Category: "Company 27",
          Type: "",
          BoothNo: "",
          BoothId: "25997000",
          BoothName: "SG Enable",
          Website: "",
          Phone: "18008585885",
          SocialLinks: {
            Facebook: "https://www.facebook.com/SGEnable/",
            Twitter: "",
            LinkedIn: "https://www.linkedin.com/company/sg-enable-ltd/?originalSubdomain=sg",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 27,
        },

        {
          Id: "28",
          Name: "King Mongkut's Institute of Technology Ladkrabang (KMITL)",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1654531152018-untitled-1.png?alt=media",
          Profile:
            "",
          Email: "",
          CategoryId: "28",
          Category: "Company 28",
          Type: "",
          BoothNo: "",
          BoothId: "25980000",
          BoothName: "King Mongkut's Institute of Technology Ladkrabang (KMITL)",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "https://www.facebook.com/kmitlofficial",
            Twitter: "",
            LinkedIn: "",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 28,
        },

        {
          Id: "29",
          Name: "HASU",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1654523541010-logo-hasu.png?alt=media",
          Profile:
            "",
          Email: "",
          CategoryId: "29",
          Category: "Company 29",
          Type: "",
          BoothNo: "",
          BoothId: "26070000",
          BoothName: "HASU",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "",
            Twitter: "",
            LinkedIn: "https://www.linkedin.com/in/thuy-anh-ngo/",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 29,
        },

        {
          Id: "30",
          Name: "City Developments Limited (CDL)",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1654566234901-cdl-logo-%5Btransparent%5D-01.png?alt=media",
          Profile:
            "<p>City Developments Limited (CDL) is a leading global real estate company with a network spanning 104 locations in 29 countries and regions. Listed on the Singapore Exchange, our income-stable and geographically-diverse portfolio comprises residences, offices, hotels, serviced apartments, integrated developments and shopping malls. In line with our ethos of ‘Conserving as We Construct’, CDL has been driving change in the built environment by championing green building innovation. We have also initiated and supported a wide range of sustainability programmes to deliver a lasting and positive impact in the communities where we operate.</p>",
          Email: "sustainability@cdl.com.sg",
          CategoryId: "29",
          Category: "Company 29",
          Type: "",
          BoothNo: "",
          BoothId: "26186000",
          BoothName: "City Developments Limited (CDL)",
          Website: "",
          Phone: "6877 8228",
          SocialLinks: {
            Facebook: "https://www.facebook.com/CDLsustainability",
            Twitter: "https://www.linkedin.com/company/37566991/admin/",
            LinkedIn: "https://www.instagram.com/cdl_sustainability/",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 30,
        },

        {
          Id: "31",
          Name: "Nanyang Polytechnic",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1654594398803-marketing-nyp-logo_cmyk.png?alt=media",
          Profile:
            "",
          Email: "",
          CategoryId: "30",
          Category: "Company 30",
          Type: "",
          BoothNo: "",
          BoothId: "25991000",
          BoothName: "Nanyang Polytechnic",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "https://www.facebook.com/nanyangpoly/",
            Twitter: "https://twitter.com/nyptweets",
            LinkedIn: "https://www.linkedin.com/school/nanyang-polytechnic/",
            Youtube: "",
            Instagram: "https://www.instagram.com/nanyangpoly/?hl=en",
          },
          Tags: "",
          DisplayOrder: 31,
        },

        {
          Id: "32",
          Name: "Amrita Vishwa Vidyapeetham",
          Logo: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1654611149296-a.png?alt=media",
          Profile:
            "",
          Email: "info@ammachilabs.org",
          CategoryId: "31",
          Category: "Company 31",
          Type: "",
          BoothNo: "",
          BoothId: "25985000",
          BoothName: "Amrita Vishwa Vidyapeetham",
          Website: "",
          Phone: "",
          SocialLinks: {
            Facebook: "",
            Twitter: "",
            LinkedIn: "",
            Youtube: "",
            Instagram: "",
          },
          Tags: "",
          DisplayOrder: 32,
        },
      ],
      PartnerCategories: [],
      searchCategoryId: "",
      searchText: "",
    };
  },
  computed: {
    FilteredPartners() {
      var result = self.Partners;
      var searchText = self.searchText
        ? self.searchText.trim().toLowerCase()
        : "";
      if (searchText) {
        result = result.filter(function (item) {
          return (
            item.Name.toLowerCase().includes(searchText) ||
            item.Profile.toLowerCase().includes(searchText) ||
            item.Tags.toLowerCase().includes(searchText)
          );
        });
      }
      if (self.searchCategoryId) {
        result = result.filter(function (item) {
          return (item.CategoryId == self.searchCategoryId);
        });
      }
      return result;
    },
  },
  created() {
    self = this;
    self.publicEventCollection = self.getPublicEventCollection();
    self.event_collectionName = self.getEventCollectionName();
  },
  mounted() {
    document.title = "Partners";
    self.getPartnerCategories();
  },
  methods: {
    getPartnerCategories() {
      self.PartnerCategories = [];
      var ids = [];
      self.PartnerCategories.push({
        Id: "",
        Name: "All",
      });
      for (var i = 0; i < self.Partners.length; i++) {
        var partner = self.Partners[i];
        if (partner.CategoryId && partner.Category && !ids.includes(partner.CategoryId)) {
          self.PartnerCategories.push({
            Id: partner.CategoryId,
            Name: partner.Category,
          });
          ids.push(partner.CategoryId);
        }
      }
    },
    openSposorBoothLink(partner) {
      self.currentPartner = null;
      if (partner) {
        self.currentPartner = partner;
        this.openSponsorDialog = true;
        
        var user = self.getSessionUserProfile();
        if (user && user.UserId && user.Email != "visitor@e2m.live") {
          self.AddEventAnalytics({ pageName: "/partners", action: "click", actionType: "", actionLabel: partner.Name });
        }
      }
    },
    goToBooth(boothId, boothName) {
      var user = self.getSessionUserProfile();
      var _boothName = boothName;
      boothName = boothName.replace(/ /g, "_");
      var eventFound = false;
      if (user && user.UserId) {
        if (
          self.event_collectionName &&
          self.event_collectionName == self.publicEventCollection
        ) {
          eventFound = true;
        
          if (user.Email != "visitor@e2m.live") {
            self.AddEventAnalytics({ pageName: "/partners", action: "click", actionType: "", actionLabel: "Enter Booth: " + _boothName });
          }
          router.push("/exhibitorsview/" + boothId + "/" + boothName);
          return;
        } else {
          //alert("Select Event");
          var mappedEvents = self.GetMappedEvents();
          for (var i = 0; i < mappedEvents.length; i++) {
            if (
              self.publicEventCollection == mappedEvents[i].EventCollectionName
            ) {
              //self.CurrentAdminEvent = mappedEvents[i];
              self.ChangeCurrentEvent(
                mappedEvents[i].ClientId,
                mappedEvents[i].EventId,
                false,
                true
              );
              setTimeout(() => {
                router.push("/exhibitorsview/" + boothId + "/" + boothName);
              }, 1000);
              eventFound = true;
              break;
            }
          }
        }
      }
      if (!eventFound) {
        let eventId = self.getPublicEventId();
        store.commit(
          "setUrlReq",
          "/exhibitorsview/" + boothId + "/" + boothName
        );
        router.push(
          "/?visitor-login=true&event_id=" +
            eventId +
            "&redirect_url=/exhibitorsview/" +
            boothId +
            "/" +
            boothName
        );
        //self.goToVisitorLogin();
      }
    },
  },
};
</script>